import { ResultReason } from 'twain-sport-fe-mono/enums';

export const getTechLossReasonTranslation = (resultReason: ResultReason): string => {
    if (resultReason === ResultReason.TECH_LOSS_OPPONENT_DISQUALIFIED) {
        return 'disqualification';
    }
    if (resultReason === ResultReason.TECH_LOSS_OPPONENT_INJURED) {
        return 'injury';
    }

    return 'tech_loss';
};

export const getTieReasonTranslation = (resultReason: ResultReason): string => {
    if (resultReason === ResultReason.TIE_ACCURACY) {
        return 'accuracy';
    }

    return 'rank';
};
